import { useEffect, useState } from 'react'
import { Anchor, Button, Group, Paper, Text } from '@mantine/core'
import { Link } from 'react-router-dom'

const STORAGE_KEY = 'cookie.notice.v1'

export default function CookieNotice() {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined') return
    try {
      if (window.localStorage.getItem(STORAGE_KEY)) return
    } catch {
      // ignore storage errors
    }
    const t = window.setTimeout(() => setOpen(true), 1200)
    return () => window.clearTimeout(t)
  }, [])

  const dismiss = () => {
    setOpen(false)
    try {
      window.localStorage.setItem(STORAGE_KEY, new Date().toISOString())
    } catch {
      // ignore storage errors
    }
  }

  if (!open) return null

  return (
    <div className="cookie-notice" aria-live="polite" role="status">
      <Paper withBorder radius="xl" p="md" shadow="sm" className="cookie-notice__card">
        <Text size="sm" c="dimmed" className="cookie-notice__text">
          Мы используем cookies и метрики для улучшения сервиса.{' '}
          <Anchor component={Link} to="/legal/privacy" size="sm">
            Политика конфиденциальности
          </Anchor>
        </Text>
        <Group justify="flex-end" mt="sm">
          <Button size="sm" radius="xl" className="cookie-notice__action" onClick={dismiss}>
            Понятно
          </Button>
        </Group>
      </Paper>
    </div>
  )
}
